import React from 'react'

import i18n from 'live/services/i18n'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { boxplotReducer } from './reducer'
import { BoxplotEvent, BoxplotState } from './types'
import { withSuspenseWrapper } from 'plugin-live-exploratory-viz/components/SuspenseWrapper'

const widgetType = 'boxplot'

const BoxplotWidget = reactWidgetWrapper<BoxplotState, FlowMessage<BoxplotEvent>, DefaultChartConfigs>(
    withSuspenseWrapper(React.lazy(() => import('./BoxplotWidgetController'))),
    boxplotReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget
            }
        }
    }
)

export const DEFAULT_CHART_CONFIG: LiveWidgetConfig = {
    verticalEnabled: true,
    legendEnabled: false,
    legendRight: false,
    tooltipType: 'individual'
}

const policies = {
    defaultReducer: ' ',
    layers: 1,
    legends: true,
    allowHideTooltip: true
}

widgetService.register({
    type: widgetType,
    get name() {
        return 'Boxplot'
    },
    policies,
    config: DEFAULT_CHART_CONFIG,
    description: i18n('boxplot description'),
    impl: BoxplotWidget
})
